import { EventEmitter, Injectable, Output } from "@angular/core";
import { Observable, of } from "rxjs";
import { Client } from "../generated-api-proxy";
import { Router } from "@angular/router";
import { AuthStrategy } from "../auth/auth-strategy";

@Injectable({
  providedIn: 'root'
})
export class ActiveUserService {
  LoggedIn(): boolean {
    return this.loggedIn;
  }
  private loggedIn: boolean = false;

  @Output() loggedInChanged = new EventEmitter<boolean>();

  constructor(private client: Client, private router: Router) {
    // Brands without a login flow (see AuthStrategy.requiresLoginFlow) authenticate implicitly
    // on every request instead, so there's no JWT exchange to wait for here.
    this.loggedIn = !AuthStrategy.requiresLoginFlow() || this.activeUserToken != null;
  }

  setActiveUserToken(initialToken: string | null) {
    sessionStorage.setItem('initialToken', initialToken ?? "");

    if (!AuthStrategy.requiresLoginFlow()) {
      // No JWT exchange for this brand (see AuthStrategy.requiresLoginFlow) — the demos page
      // still routes through `/dashboard/:jwt` to pick a test account, but here that value is
      // only stashed in sessionStorage for LsAuthStrategy to pick up as the dev auth token.
      return;
    }

    this.activeUserToken = null;
    this.loggedIn = false;

    this.client.auth().subscribe({
      next: response => {
        this.loggedIn = true;
        this.activeUserToken = response.jwt;
        this.loggedInChanged.emit(true);
        if (this.router.url.startsWith("/dashboard")) {
          this.router.navigate(['/dashboard']);
        }
      },
      error: error => {
        this.loggedIn = false;
        this.loggedInChanged.emit(false);
        this.router.navigate(['/error']);
      }
    });
  }

  private get activeUserToken(): string | null {
    return sessionStorage.getItem('userToken');
  }

  private set activeUserToken(userToken: string | null) {
    if (userToken === null) {
      sessionStorage.removeItem('userToken');
    }
    sessionStorage.setItem('userToken', userToken ?? "");
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
      // Let the app keep running by returning an empty result.
      return of(result as T);
    }
  }
}
